import RSA256 from '@/shared/utils/RSA256'
import formatDate from '@/shared/utils/format-date'

function Params (data, method) {
  const date = formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss')

  const params = {
    charset: 'utf-8',
    biz_content: JSON.stringify(data),
    method: method,
    format: 'json',
    sign: '',
    app_id: process.env.NODE_ENV === 'production' ? '20191011632233178303561728' : '20191011632233178303561728',
    sign_type: 'RSA2',
    version: '1.0',
    timestamp: date
  }

  params.sign = RSA256(JSON.stringify(data), method, date)

  return params
}

export default Params
